export enum OrderStatus {
  OPEN = "Open",
  COMPLETE = "Complete",
  EXPIRED = "Expired",
}
